import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "animate.css";
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import wcSwiper from 'wc-swiper'
import 'wc-swiper/style.css'
Vue.use(wcSwiper);
import axios from "axios";
import './assets/js/rem.js';
import Vant from 'vant';
import 'vant/lib/index.css';
import jquery from "jquery";
Vue.prototype.$ = jquery;



import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(VideoPlayer)

Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.config.productionTip = false;

import http from "../http.js"
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js